import { ArrowRight, Smartphone, Sparkles, PackageCheck } from "lucide-react";
import { FadeUp } from "./Reveal";
import { BOOKING_LINKS } from "../config";

const steps = [
  {
    icon: Smartphone,
    step: "Step 1",
    title: "Place your order",
    body: "Book online or in the Spintastic app. Ordering is powered by Cents & Laundroworks — quick, secure, and effortless.",
  },
  {
    icon: Sparkles,
    step: "Step 2",
    title: "We work our magic",
    body: "Your laundry is washed, dried, and folded with care by our team — every item treated like it's our own.",
  },
  {
    icon: PackageCheck,
    step: "Step 3",
    title: "Fresh at your door",
    body: "Our van — or one of our trusted gig drivers — delivers your crisp, clean bundles right back to you.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="order"
      data-testid="how-it-works-section"
      className="scroll-mt-28 bg-[#1A1A1A] py-32 text-[#F9F6F0] lg:py-40"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <FadeUp className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C85C40]">
            How it works
          </p>
          <h2 className="mt-4 font-serif text-4xl leading-none tracking-tight sm:text-5xl lg:text-6xl">
            Ordering, made <span className="italic text-[#C85C40]">effortless</span>.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#F9F6F0]/60 md:text-lg">
            From your phone to your front porch in three simple steps.
          </p>
        </FadeUp>

        <div className="mt-20 grid gap-6 md:grid-cols-3 lg:gap-8">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <FadeUp
                key={s.title}
                delay={i * 0.12}
                className="group rounded-[24px] border border-white/10 bg-white/[0.04] p-8 transition-[background-color,border-color] duration-500 hover:border-[#C85C40]/40 hover:bg-white/[0.07] lg:p-10"
                data-testid={`how-it-works-step-${i + 1}`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#C85C40]/15 text-[#C85C40] transition-transform duration-500 group-hover:scale-110">
                  <Icon className="h-5 w-5" />
                </span>
                <p className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-[#F9F6F0]/40">
                  {s.step}
                </p>
                <h3 className="mt-2 font-serif text-2xl tracking-tight sm:text-3xl">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-[#F9F6F0]/60">
                  {s.body}
                </p>
              </FadeUp>
            );
          })}
        </div>

        <FadeUp delay={0.2} className="mt-16 flex flex-wrap items-center gap-4">
          <a
            href={BOOKING_LINKS.pickupDelivery}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="order-pickup-delivery-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-[#C85C40] px-8 py-4 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:scale-[0.98] hover:bg-[#A84C34]"
          >
            Schedule Pickup &amp; Delivery
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
